import { useEffect, useRef, useState } from 'react';
import { LinkToApps } from './link_to_apps.component';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

interface AppLinkProps {
  appKey: string;
}

const AppLink: React.FC<AppLinkProps> = ( { appKey } ) => {
  const { t } = useTranslation();
  const [ isPopupVisible, setIsPopupVisible ] = useState( false );

  const popupRef = useRef<HTMLSpanElement | null>( null );
  const buttonRef = useRef<HTMLButtonElement | null>( null );

  const togglePopup = () => {
    setIsPopupVisible( prev => {return !prev;} );
  };

  useEffect( () => {
    const handleClickOutside = ( event: MouseEvent ) => {
      const popup = popupRef.current;
      const button = buttonRef.current;
      const target = event.target as Node;

      if ( !popup || !button ) {
        return;
      }

      const isClickInsidePopup = popup.contains( target );
      const isClickOnButton = button.contains( target );

      if ( !isClickInsidePopup && !isClickOnButton ) {
        setIsPopupVisible( false );
      }
    };

    if ( isPopupVisible ) {
      document.addEventListener( 'mousedown', handleClickOutside );
    }

    return () => {
      document.removeEventListener( 'mousedown', handleClickOutside );
    };
  }, [ isPopupVisible ] );

  return (
    <div className="relative">
      <button
        ref={buttonRef}
        className="relative text-lg font-umanforge text-left w-32"
        onClick={togglePopup}
        aria-haspopup="true"
        aria-expanded={isPopupVisible}
      >
        {t( 'common:apps.' + appKey.toLowerCase() )}
      </button>
      {isPopupVisible && (
        <span
          ref={popupRef}
          className="absolute left-0 top-full -translate-y-2 mt-2 bg-white shadow-lg rounded-lg p-2"
        >
          <LinkToApps />
        </span>
      )}
    </div>
  );
};

AppLink.propTypes = {
  appKey: PropTypes.string.isRequired,
};

export { AppLink };
